import React from 'react';
import { FaArrowUp } from 'react-icons/fa';

import { Btn } from './Style';

export default function GotoTop() {
	window.onscroll = () => {
		scrollFunction();
	};

	const scrollTopFunction = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	const scrollFunction = () => {
		var mybutton = document.getElementById('topBtn');
		if (
			document.body.scrollTop > 260 ||
			document.documentElement.scrollTop > 260
		) {
			if (mybutton) {
				mybutton.style.display = 'block';
			}
		} else {
			if (mybutton) {
				mybutton.style.display = 'none';
			}
		}
	};

	return (
		<div>
			<Btn id="topBtn" title="Нажмите, чтобы вернуться в начало страницы" onClick={scrollTopFunction}>
				<FaArrowUp className="scroll-button" size="1.4em" />
			</Btn>
		</div>
	);
}